import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, catchError, switchMap, concatMap, tap } from 'rxjs/operators';
import { LobbyService } from '../../shared/services/lobby.service';
import * as LobbyCentralViewActions from './actions/lobby-central-views.actions';
import * as LobbyCentralLocationViewActions from './actions/lobby-central-location-view.actions';
import { of } from 'rxjs';
import { MessageHubService } from 'src/app/shared/services/message-hub.service';
import * as MessageHubActions from '../../../state/actions/message-hub.actions';
import * as CentralLocationSelectorActions from './actions/lobby-central-view-location-selector.actions';
import { ToastService } from 'src/app/shared/services/toast.service';


@Injectable()
export class LobbyCentralViewEffects {

    constructor(
        private actions$: Actions,
        private lobbyService: LobbyService,
        private messageHubService: MessageHubService,
        private toastService : ToastService) { }


    loadCentralStaffStatusGridViewData$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(LobbyCentralViewActions.loadCentralStaffStausViewGridData),
                switchMap(action => {
                    this.messageHubService.subscribeToCentralStaffStatusGridGroup(action.gridParams);
                    return of(MessageHubActions.joinCentralStaffStatusGroupActionComplete());
                })
            );
    });

    loadCentralLobbyGridViewData$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(LobbyCentralViewActions.loadCentralLobbyViewGridData),
                switchMap(action => {
                    this.messageHubService.subscribeToCentralLobbyEntryGridGroup(action.gridParams);
                    return of(MessageHubActions.joinCentralLobbyGroupActionComplete());
                })
            );
    });

    subscribeTOCentralLocationGridViewData$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(LobbyCentralLocationViewActions.subscribeToCentralLocationGridData),
                switchMap(action => {
                    this.messageHubService.subscribeToCentralBranchGridGroup(action.centralGridViewFilter);
                    return of(MessageHubActions.joinCentralLocationGroupActionComplete());
                })
            );
    });

    centralLocationSelectorItemChanged$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(CentralLocationSelectorActions.centralLocationSelectorItemChanged),
                switchMap(() => {
                    return of(LobbyCentralLocationViewActions.reSubscribtionToCentralLocationGridData());
                })
            );
    });

    loadAllLocations$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(CentralLocationSelectorActions.loadAllLocations),
                mergeMap(action => this.lobbyService.getAllLocations()
                    .pipe(
                        map(locationIds => CentralLocationSelectorActions.loadCentralLobbyLocationDataSuccess(
                            { locationData: locationIds })),
                        catchError(error => of(LobbyCentralViewActions.loadAllLocationsError({ error })))
                    )
                )
            );
    });

}
